import { ImageLoaderConfig } from '@angular/common';
import { getImageCdnUrl } from '@pedix-workspace/utils';
import { ImageLoaderParams, PRESET_SIZES } from '../image.types';

/**
 * Encuentra el tamaño preset más cercano que sea >= al tamaño solicitado.
 * Si el tamaño solicitado es mayor al preset más grande, retorna el preset más grande.
 */
function getNearestPresetSize(requestedSize: number): number {
  return PRESET_SIZES.find(size => size >= requestedSize) || PRESET_SIZES[PRESET_SIZES.length - 1];
}

export function createPedixImageLoader(env: 'development' | 'production') {
  return (config: ImageLoaderConfig): string => {
    const src = config.src;
    const loaderParams = <ImageLoaderParams>(config.loaderParams || {});

    // Para srcset automático (density-based o responsive)
    const requestedSize = config.width || loaderParams.imageSize;
    const targetSize = getNearestPresetSize(requestedSize);

    const imageUrl = getImageCdnUrl(
      src,
      {
        size: `${targetSize}x${targetSize}`,
        quality: loaderParams.quality,
      },
      env,
    );

    return imageUrl;
  };
}
